<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <integration-settings-form
      ref="form"
      :model="model"
      :integration="integration"
      :save-endpoint="saveEndpoint"
      v-if="model"
    ></integration-settings-form>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import IntegrationSettingsForm from '@/modules/integrations/components/IntegrationSettingsForm'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationSettings',

  components: { IntegrationSettingsForm, RestPage },

  data() {
    return {
      model: null,
      rules: {}
    }
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    modelId: {
      type: Number,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/${this.modelId}`,
        handler: data => {
          this.model = { config: {}, ...data }
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: `integrations/${this.modelId}`
      })
    }
  },

  methods: {
    save() {
      return this.$refs['form'].save()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationSettings.vue